import { Typography } from '@mui/material';
import { Box, useMediaQuery } from '@mui/system';
import React, { useEffect, useState } from 'react';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight'
import useStore from '../../state-files/zustondStoreStates';
import SidebarGetList from './SidebarGetList';

const Sidebar = () => {
    const isMobile = useMediaQuery('(max-width:1300px)');
    const { communities, sidebarDiscussions, communitiesExpanded, setCommunitiesExpanded, discussionExpanded, setDiscussionExpanded } = useStore();
    const [attempts, setAttempts] = useState(0);

    React.useEffect(() => {
        if ((sidebarDiscussions.length < 1 || communities.length < 1) && attempts < 2) { 
            setAttempts(prev => prev + 1);
        }
    }) //Fetches all the users discussions regardless of the page they are on

    return (
        <Box className={isMobile ? 'hidden' : ''} sx={{
            flexDirection: 'column',
            display: { xs: 'none', md: 'flex' },
            paddingLeft: 1,
            width: '20vw',
            height: '95vh',
            backgroundColor: 'rgba(23, 126, 38, 0.36)',
        }}>

            <Typography onClick={() => {
                if (discussionExpanded) {
                    setDiscussionExpanded(false);
                } else {
                    setDiscussionExpanded(true);

                }
            }} sx={{
                display: 'flex',
                paddingTop: 1,
                cursor: 'pointer'
            }} variant='h5'>Discussions {!discussionExpanded && (
                <KeyboardArrowRightIcon />)}

                {discussionExpanded && (<KeyboardArrowDownIcon />)}</Typography>
            <SidebarGetList itemList={sidebarDiscussions} isExpanded={discussionExpanded} />


            <Typography onClick={() => {
                if (communitiesExpanded) {
                    setCommunitiesExpanded(false);
                } else {
                    setCommunitiesExpanded(true);
                }
            }} sx={{
                display: 'flex',
                paddingTop: 1,
                cursor: 'pointer'
            }} variant='h5'>Communities {!communitiesExpanded && (
                <KeyboardArrowRightIcon />)}
                {communitiesExpanded && (<KeyboardArrowDownIcon />)}</Typography>
            <SidebarGetList itemList={communities} isExpanded={communitiesExpanded} />
        </Box>
    )
};

export default Sidebar;